// Copy shown inside the trading-journal product mock-up (Figma 3165:29366 / 3205:61792).
// Everything here is decorative: the scene is one `role="img"` for assistive tech.

export const INBOX_UI = {
  breadcrumb: ["Breadcrumb", "Trading Journal", "Inbox"],
  month: "February 2026",
  listTitle: "Executions waiting for review",
  ignoreAll: "Ignore All",
  process: "Process all",
  tabs: ["Waiting for enrichment", "Already enriched"],
  columns: ["Type", "Amount", "Price (unit)", "Date", "Options"],
} as const;

export type InboxDay = {
  weekday: string;
  day: string;
  pnl: string;
  selected?: boolean;
  muted?: boolean;
};

// Thu 12 Feb 2026 is the selected day in the design.
export const INBOX_DAYS: InboxDay[] = [
  { weekday: "TUE", day: "10", pnl: "+512$" },
  { weekday: "WED", day: "11", pnl: "+254$" },
  { weekday: "THU", day: "12", pnl: "+124$", selected: true },
  { weekday: "FRI", day: "13", pnl: "+930$" },
  { weekday: "SAT", day: "14", pnl: "+876$" },
  { weekday: "SUN", day: "15", pnl: "+43$", muted: true },
];

export type InboxRow = {
  side: "buy" | "sell";
  amount: string;
  price: string;
  date: string;
};

export const INBOX_ROWS: InboxRow[] = [
  { side: "buy", amount: "0.1 BTC", price: "$ 34.000", date: "Mar 08, 2024" },
  { side: "sell", amount: "0.4 ETH", price: "$ 2.180", date: "Mar 08, 2024" },
  { side: "buy", amount: "1.2 SOL", price: "$ 148", date: "Mar 07, 2024" },
];

export const WIZARD_UI = {
  title: "New Trade",
  subtitle: "Complete all steps to save",
  steps: [
    { title: "Trade Setup", text: "Account, direction & timing" },
    { title: "Mindset & Strategy", text: "Emotions & rules" },
    { title: "Notes & Images", text: "Documentation" },
  ],
  account: { label: "Trading Account", value: "Test Merge", tag: "USD" },
  pair: { label: "Trading pair", value: "6CU6" },
  direction: ["Long", "Short"],
  stopLoss: { label: "Planed Stop Loss", value: "65000$" },
  takeProfit: { label: "Planed Take Profit (Target)", value: "80000$" },
  entries: {
    label: "ENTRYS",
    columns: ["price", "quantity", "Order Type", "date", "Time"],
    rows: [{ price: "US$ 24,00", quantity: "2", type: "Market", date: "May 10, 2025", time: "9:13 PM" }],
    inputs: ["price", "quantity", "Limit Order", "date", "Time"],
  },
  exits: {
    label: "EXIT",
    columns: ["price", "quantity", "Order Type", "date", "Time"],
    rows: [
      { price: "US$ 25,62", quantity: "1", type: "Limit", date: "May 10, 2025", time: "9:13 PM" },
      { price: "US$ 26,2", quantity: "1", type: "Market", date: "May 10, 2025", time: "9:13 PM" },
    ],
    add: "Add new Exit",
  },
  options: ["Add fees", "Break even Trade", "Missed Trade"],
  back: "Go back",
  netPnl: { label: "Net PnL", value: 2234 },
  avgRr: { label: "Avg R:R", value: "1 : 2.1" },
  next: "Continue",
} as const;
